import Header from '@carvana/header';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import React, { memo, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Summary } from '|/app/services';
import UserInitializationContext from '|/context/user-initialization-context';
import styles from './header-mfe.module.css';

interface HeaderMfeProps {
  orderSummary?: Summary | null;
}

interface HeadProps {
  Component?: typeof Header;
}

const getChatContext = (vehicleId: number | null = null) => ({
  purchase: {
    vehicle: {
      vehicleId
    }
  }
});

const HeaderMfe: React.FC<HeaderMfeProps> = ({ orderSummary = null }) => {
  const {
    vehicle = null,
    vehicle: { id: vehicleId = null } = {},
    totals: { totalPrice: vehicleTotalPrice = null } = {}
  } = orderSummary || {};

  const { accessToken } = useContext(UserInitializationContext);
  const isLoggedIn = accessToken?.user?.name !== undefined;
  const location = useLocation();

  const currentRoute = (location && location.pathname) || '';
  const chatContext = vehicle === null ? null : getChatContext(vehicleId);

  const Head = memo<HeadProps>(({ Component = Header }) => (
    <Component
      environment={process.env.CVNA_APP_ENVIRONMENT}
      isLoggedInExternally={isLoggedIn}
      purchaseProcessVehiclePrice={vehicleTotalPrice}
      useProvider
      currentRoute={currentRoute}
      chatContext={chatContext}
      shouldLoadPlugin={false}
    />
  ));

  return (
    <div className={styles.headerWrapper}>
      <MfeReactComponent component="default" module="HeaderModule" loading={<Head />}>
        {({ Component: HeaderComponent }: { Component: any }) => (
          <Head Component={HeaderComponent} />
        )}
      </MfeReactComponent>
    </div>
  );
};

export default HeaderMfe;
